import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import * as THREE from 'three';
import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js';

export const EThreejsStub = {
  /*
   * RENDERER
   */
  RENDERER: new THREE.WebGLRenderer(),

  /*
   * SCENE
   */
  SCENE: new THREE.Scene(),

  /*
   * CAMERAS
   */
  CAMERA_ORTHOGRAPHIC: new THREE.OrthographicCamera(),
  CAMERA_PERSPECTIVE: new THREE.PerspectiveCamera(),

  /*
   * CONTROLS
   */
  TRANSFORM_CONTROL: new TransformControls(new THREE.PerspectiveCamera(), ENUM__html_ref_stub.CANVAS),

  /*
   * HELPERS
   */
  AXES_HELPER: new THREE.AxesHelper(),
  GRID_HELPER: new THREE.GridHelper(),

  /*
   * LIGHTS
   */
  LIGHT_AMBIENT: new THREE.AmbientLight(),

  /*
   * MATERIAL
   */

  MATERIAL: new THREE.MeshBasicMaterial(),

  /*
   * OBJECTS / GROUPS
   */
  GROUP: new THREE.Group(),
  LINE_SEGMENTS: new THREE.LineSegments(),
  MESH: new THREE.Mesh(),
  OBJECT: new THREE.Object3D(),

  /*
   * RAYCASTING
   */
  RAYCASTER: new THREE.Raycaster(),

  /*
   * TEXTURES
   */
  TEXTURE: create_texture(),
  CANVAS_TEXTURE: create_canvas_texture(),

  /*
   * MATH / GEOMETRY DATA
   */
  PLANE: new THREE.Plane(),
  VECTOR_3: new THREE.Vector3(),

  /*
   * SELECTION INFO (STRUCT)
   */
  SELECTED_NODE_INFO: {
    body: new THREE.Object3D(),
    child_bones: [],
    child_nodes: [],
    fixed_length_mode: false,
    node: new THREE.Object3D(),
    node_name: '',
    original_bone_lengths: {},
    original_position: new THREE.Vector3(),
    parent_bone: new THREE.Object3D(),
    parent_nodes: [],
  },
};

function create_canvas_texture() {
  const canvas = document.createElement('canvas');
  canvas.width = 1;
  canvas.height = 1;
  const ctx = canvas.getContext('2d')!;
  ctx.fillStyle = '#000';
  ctx.fillRect(0, 0, 1, 1);

  const texture = new THREE.CanvasTexture(canvas);

  return texture;
}

function create_texture() {
  const canvas = document.createElement('canvas');
  canvas.width = 1;
  canvas.height = 1;
  const ctx = canvas.getContext('2d')!;
  ctx.fillStyle = '#000';
  ctx.fillRect(0, 0, 1, 1);

  const texture = new THREE.Texture(canvas);

  return texture;
}
